import type { TFunction } from '@frontend/i18n';
import type { PaymentMethodSetupKind } from '../types';

/** Cards map known decline codes; ACH always uses generic copy. */
export const getSetupErrorMessage = (kind: PaymentMethodSetupKind, code: string | undefined, t: TFunction) => {
  if (kind === 'ach') {
    return t('Unable to save ACH. Please try again. {{errorCode}}', { errorCode: code ?? '' }).trim();
  }

  switch (code) {
    case 'incorrect_number':
      return t('The card number appears to be incorrect. Please check and try again.');
    case 'expired_card':
      return t('The card has expired. Please check the expiration date or use a different card.');
    case 'incorrect_cvc':
      return t("The card's security code is incorrect. Please check the card's security code or use a different card.");
    case 'invalid_cvc':
      return t("The card's security code is invalid. Please check the card's security code or use a different card.");
    case 'incorrect_zip':
      return t("The card's postal code is incorrect. Please check the card's postal code or use a different card.");
    case 'invalid_expiry_month':
      return t("The card's expiration month is invalid. Please check the expiration date or use a different card.");
    case 'invalid_expiry_year':
      return t("The card's expiration year is invalid. Please check the expiration date or use a different card.");
    default:
      return t('Unable to save Card. Please try again. {{errorCode}}', { errorCode: code ?? '' }).trim();
  }
};

export const getGenericSetupErrorMessage = (kind: PaymentMethodSetupKind, t: TFunction) =>
  kind === 'card' ? t('Unable to save Card. Please try again.') : t('Unable to save ACH. Please try again.');
